import axios from "axios";

export const skipPrescriptionsAcknowledgmentRequest =
  async (): Promise<void> => {
    await axios.post(`/api/checkins/prescriptions`, { skipped: true });
  };
